import type { Code } from 'mdast'
import * as React from 'react'

import { styled } from '~/styled'

type MarkdownCodeProps = {
  node: Code
}

const StyledMarkdownCode = styled('div', {
  base: [
    'bg-grey-200',
    'rounded-md',
    'text-grey-1000',
    'font-mono',
    'text-sm/[1.4]',
    'my-4',
    'p-3'
  ]
})

export const MarkdownCode = ({ node }: MarkdownCodeProps) => (
  <StyledMarkdownCode as="pre">{node.value}</StyledMarkdownCode>
)
